import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {StateAssignment} from '../../../../shared/models/socialSupport/stateAssignments';
import {AppActions} from '../../../actions';

export interface StateAssignmentsState {
  assignments: StateAssignment[] | null;
}

const initialState: StateAssignmentsState = {
  assignments: null,
};

export const stateAssignmentsSlice = createSlice({
  name: '@@eskso/socialSupport/stateAssignments',
  initialState,
  reducers: {
    setStateAssignment: (state, action: PayloadAction<StateAssignment[]>) => {
      return {
        ...state,
        assignments: action.payload,
      };
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const stateAssignments = stateAssignmentsSlice.reducer;
